import Pen from '../../src/legacy/Pen';
export default Pen;
